<!-- @format -->

@if (validColors()?.length) {
	<div class="swatches hmf-display-flex hmf-align-items-center">
		@for (
			color of validColors() | slice: 0 : maxColorSwatchesToShow();
			track trackBySwatch($index, color)
		) {
				@let swatchImageUrl = imageSourceMap().get(color)?.() ?? '';
				<hmf-selector
					class="hmf-m-xxxs"
					circleVariant="xsmall"
					radius="50%"
					selector="circular"
					[height]="'20px'"
					[width]="'20px'"
					[color]="color"
					[imageSrc]="swatchImageUrl"
					[selected]="selectedSwatchColor() === color"
					[attr.title]="color"
					(mouseover)="setImageColor(color)"
					(focus)="setImageColor(color)"
					(imageError)="handleImageError({ requestedImg: swatchImageUrl, color: color })"
				></hmf-selector>
		}

		@if (validColors().length > maxColorSwatchesToShow()) {
			<!-- lint rules are incorrectly erroring here because hmf-text-link has host binding for href attribute, but eslint thinks it's not interactable because href isn't here -->
			<!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
			<a
				hmf-text-link
				variant="secondary"
				class="hmf-m-xxxs"
				[ariaLabel]="moreColorsButtonAriaLabel()"
				[linkURL]="assetSeoUrl()"
				(click)="extraColorsClicked($event)"
				(keydown.space)="extraColorsClicked($event)">
				{{ remainingColors() }}+
			</a>
		}
	</div>
}
